import { useEffect, useRef, useState } from 'react';

import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';

import LocalText from '@/localization/local_text';
import { trackList as trackListAPI } from '@/network/apis/apiUri';

export default function ProgramTrackList(props) {
  const { mode, boardId } = props;

  const formatter = mode.includes('en') ? 'dddd, DD MMMM YYYY' : 'YYYY년 MM월 DD일 dddd';
  const minDate = dayjs.tz().subtract(1, 'month');

  const btnSelectDate = useRef();

  const [selectData, setSelectDate] = useState(dayjs.tz());
  const [trackList, setTrackList] = useState();

  const openDatePicker = () => {
    btnSelectDate.current.onInputClick();
  };

  const handleArrow = (e) => {
    const { value } = e.currentTarget;

    if (value === 'prev') {
      minDate > selectData ? setSelectDate(minDate) : setSelectDate(selectData.subtract(1, 'day'));
    }
    if (value === 'next') {
      setSelectDate(selectData.add(1, 'day'));
    }
  };

  useEffect(() => {
    trackListAPI({
      board_id: boardId,
      is_template: false,
      start_broadcast_date: selectData.format('YYYY-MM-DD'),
      end_broadcast_date: selectData.format('YYYY-MM-DD'),
      page_info: { row_count: 10, number: 0 },
    }).then((res) => {
      if (res.status === 200) {
        const dataExist = res.data.item.length;
        if (dataExist) {
          const data = res.data.item[0].tracklist_item
            .filter((el) => el.useage_type === 'general')
            .reduce((acc, cur) => {
              const partNo = cur.part_no;
              if (!acc[partNo]) acc[partNo] = [];
              acc[partNo].push({
                id: cur.id,
                partNo: cur.part_no,
                artist: cur.artist.find((el) => el.lan_code === mode).text,
                content: cur.content.find((el) => el.lan_code === mode).text,
                title: cur.title.find((el) => el.lan_code === mode).text,
              });
              return acc;
            }, []);

          setTrackList(data);
        }
      }
    });
    return () => setTrackList(undefined);
  }, [selectData]);

  return (
    <div id="RadioProgramTracklist" className="radioProgramTracklist">
      <div className="radioProgramTracklist_title-wrap">
        <h2 className="radioProgramTracklist_title">Tracklist</h2>
        <div className="radioProgramTracklist_date">{selectData.format(formatter)}</div>
        <div className="radioProgramTracklist_selDate-wrap">
          <div className="radioProgramTracklist_selDate">
            <DatePicker
              ref={btnSelectDate}
              className="btnSelectDate sr-only"
              selected={selectData.toDate()}
              minDate={minDate.toDate()}
              onChange={(date) => setSelectDate(dayjs(date))}
              dateFormat="yyyy. MM. dd"
            />
            <button type="button" className="btnSelect" onClick={openDatePicker}>
              <span className="sr-only">Select Day</span>
            </button>
          </div>
          <div className="radioProgramTracklist_btnWrap">
            <button type="button" className="btnPrevDate active" value="prev" onClick={handleArrow}>
              <span className="sr-only">Previous Day</span>
            </button>
            <button type="button" className="btnNextDate active" value="next" onClick={handleArrow}>
              <span className="sr-only">Next Day</span>
            </button>
          </div>
        </div>
      </div>
      {!trackList && (
        <div className="radioProgramTracklist_content">
          <table className="table">
            <caption className="sr-only">트랙리스트1</caption>
            <colgroup>
              <col width="12%" />
              <col width="*" />
              <col width="*" />
            </colgroup>
            <thead className="table_head">
              <tr className="table_row notice">
                <th className="table_row_head track-part" scope="col">
                  Part1
                </th>
                <th className="table_row_head track" scope="col">
                  Title
                </th>
                <th className="table_row_head track" scope="col">
                  Artist
                </th>
              </tr>
            </thead>
            <tbody className="table_body">
              <tr className="table_row alert">
                <td className="table_row_data style_center" colSpan={3}>
                  <div className="alert">
                    <img
                      className="alert_img"
                      src={require('@/assets/images/icon/ico_alert.png').default}
                      alt="There is no playlist yet"
                    />
                    <p className="alert_text">
                      <LocalText txt={'radio_program_tracklist_nodata'} />
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {trackList &&
        trackList.map((track, i) => (
          <div className="radioProgramTracklist_content" key={`trackPart_${i + 1}`}>
            <table className="table">
              <caption className="sr-only">트랙리스트1</caption>
              <colgroup>
                <col width="12%" />
                <col width="*" />
                <col width="*" />
              </colgroup>
              <thead className="table_head">
                <tr className="table_row notice">
                  <th className="table_row_head track-part" scope="col">
                    Part{i + 1}
                  </th>
                  <th className="table_row_head track" scope="col">
                    Title
                  </th>
                  <th className="table_row_head track" scope="col">
                    Artist
                  </th>
                </tr>
              </thead>
              <tbody className="table_body">
                {track.map((v) => (
                  <tr className="table_row" key={v.id}>
                    <td className="table_row_data track" colSpan="2">
                      {v.title}
                    </td>
                    <td className="table_row_data">{v.artist}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
    </div>
  );
}
